export default __webpack_public_path__ + "static/youcat-logo.3a573602.svg";